import {
  OPERATOR_TYPES_1,
  OPERATOR_TYPES_3,
  OPERATOR_TYPES_5,
} from 'dashboard/components/widgets/FilterInput/FilterOperatorTypes.js';

export const BROADCAST_REPORT_METRICS = [
  {
    NAME: 'CAMPAIGN.BROADCAST_REPORT.METRIC.SEND',
    KEY: 'send',
    DESC: '( total )',
  },
  {
    NAME: 'CAMPAIGN.BROADCAST_REPORT.METRIC.FAILED',
    KEY: 'failed',
    DESC: '( total )',
  },
  {
    NAME: 'CAMPAIGN.BROADCAST_REPORT.METRIC.BROADCAST',
    KEY: 'broadcast_amount',
    DESC: '( total )',
  },
  {
    NAME: 'CAMPAIGN.BROADCAST_REPORT.METRIC.RECIPIENT',
    KEY: 'recipient',
    DESC: '( total )',
  },
];

export const AI_CAMPAIGN_REPORT_METRIC = [
  {
    NAME: 'CAMPAIGN.LLM_CHATBOT.AI_BROADCAST_LIST.CALL_CAMPAIGN.REPORT.SUCCESS',
    KEY: 'success',
    DESC: '( total )',
    isCallReport: true,
  },
  {
    NAME: 'CAMPAIGN.LLM_CHATBOT.AI_BROADCAST_LIST.CALL_CAMPAIGN.REPORT.FAIL',
    KEY: 'failure',
    DESC: '( total )',
    isCallReport: true,
  },
  {
    NAME: 'CAMPAIGN.LLM_CHATBOT.AI_BROADCAST_LIST.CALL_CAMPAIGN.REPORT.UNKNOWN',
    KEY: 'unknown',
    DESC: '( total )',
    isCallReport: true,
  },
  {
    NAME: 'CAMPAIGN.LLM_CHATBOT.AI_BROADCAST_LIST.CALL_CAMPAIGN.REPORT.COST',
    KEY: 'total_cost',
    DESC: '( total )',
    isCallReport: true,
  },
  {
    NAME:
      'CAMPAIGN.LLM_CHATBOT.AI_BROADCAST_LIST.CALL_CAMPAIGN.REPORT.DURATION',
    KEY: 'total_duration',
    DESC: '( total )',
    isCallReport: true,
  },
  {
    NAME:
      'CAMPAIGN.LLM_CHATBOT.AI_BROADCAST_LIST.CALL_CAMPAIGN.REPORT.RECIPIENT',
    KEY: 'recipient',
    DESC: '( total )',
    isCallReport: false,
  },
];

export const AI_AGENT_CALL_REPORT_STATUS = [
  {
    id: 'failure',
    title:
      'CAMPAIGN.LLM_CHATBOT.AI_BROADCAST_LIST.AGENT_CALL_REPORT.STATUS.FAILURE',
  },
  {
    id: 'success',
    title:
      'CAMPAIGN.LLM_CHATBOT.AI_BROADCAST_LIST.AGENT_CALL_REPORT.STATUS.SUCCESS',
  },
  {
    id: 'unknown',
    title:
      'CAMPAIGN.LLM_CHATBOT.AI_BROADCAST_LIST.AGENT_CALL_REPORT.STATUS.UNKNOWN',
  },
];

export const AI_AGENT_CALL_REPORT_SORT_LIST = [
  {
    id: 0,
    order: 'created_at',
    direction: 'asc',
    title:
      'CAMPAIGN.LLM_CHATBOT.AI_BROADCAST_LIST.AGENT_CALL_REPORT.SORT.CREATED_AT_ASC',
  },
  {
    id: 1,
    order: 'created_at',
    direction: 'desc',
    title:
      'CAMPAIGN.LLM_CHATBOT.AI_BROADCAST_LIST.AGENT_CALL_REPORT.SORT.CREATED_AT_DESC',
  },
  {
    id: 2,
    order: 'total_duration',
    direction: 'asc',
    title:
      'CAMPAIGN.LLM_CHATBOT.AI_BROADCAST_LIST.AGENT_CALL_REPORT.SORT.TOTAL_DURATION_ASC',
  },
  {
    id: 3,
    order: 'total_duration',
    direction: 'desc',
    title:
      'CAMPAIGN.LLM_CHATBOT.AI_BROADCAST_LIST.AGENT_CALL_REPORT.SORT.TOTAL_DURATION_DESC',
  },
  {
    id: 4,
    order: 'total_cost',
    direction: 'asc',
    title:
      'CAMPAIGN.LLM_CHATBOT.AI_BROADCAST_LIST.AGENT_CALL_REPORT.SORT.TOTAL_COST_ASC',
  },
  {
    id: 5,
    order: 'total_cost',
    direction: 'desc',
    title:
      'CAMPAIGN.LLM_CHATBOT.AI_BROADCAST_LIST.AGENT_CALL_REPORT.SORT.TOTAL_COST_DESC',
  },
];

export const AI_CAMPAIGN_STATUS = [
  // {id: 'failure', title: 'CAMPAIGN.LLM_CHATBOT.AI_BROADCAST_LIST.CALL_CAMPAIGN.FILTER.STATUS.FAILURE'},
  // {id: 'success', title: 'CAMPAIGN.LLM_CHATBOT.AI_BROADCAST_LIST.CALL_CAMPAIGN.FILTER.STATUS.SUCCESS'},
  // {id: 'unknown', title: 'CAMPAIGN.LLM_CHATBOT.AI_BROADCAST_LIST.CALL_CAMPAIGN.FILTER.STATUS.UNKNOWN'},
  {
    id: 0,
    title:
      'CAMPAIGN.LLM_CHATBOT.AI_BROADCAST_LIST.CALL_CAMPAIGN.FILTER.STATUS.PENDING',
  },
  {
    id: 1,
    title:
      'CAMPAIGN.LLM_CHATBOT.AI_BROADCAST_LIST.CALL_CAMPAIGN.FILTER.STATUS.ACTIVE',
  },
  {
    id: 2,
    title:
      'CAMPAIGN.LLM_CHATBOT.AI_BROADCAST_LIST.CALL_CAMPAIGN.FILTER.STATUS.RUNNING',
  },
  {
    id: 3,
    title:
      'CAMPAIGN.LLM_CHATBOT.AI_BROADCAST_LIST.CALL_CAMPAIGN.FILTER.STATUS.COMPLETED',
  },
  {
    id: 4,
    title:
      'CAMPAIGN.LLM_CHATBOT.AI_BROADCAST_LIST.CALL_CAMPAIGN.FILTER.STATUS.DEACTIVE',
  },
];

export const AI_CAMPAIGN_SORT_LIST = [
  {
    id: 0,
    order: 'recipient_count',
    direction: 'asc',
    title:
      'CAMPAIGN.LLM_CHATBOT.AI_BROADCAST_LIST.CALL_CAMPAIGN.FILTER.SORT.TOTAL_RECIPIENT_ASC',
  },
  {
    id: 1,
    order: 'recipient_count',
    direction: 'desc',
    title:
      'CAMPAIGN.LLM_CHATBOT.AI_BROADCAST_LIST.CALL_CAMPAIGN.FILTER.SORT.TOTAL_RECIPIENT_DESC',
  },
  {
    id: 2,
    order: 'scheduled_at',
    direction: 'asc',
    title:
      'CAMPAIGN.LLM_CHATBOT.AI_BROADCAST_LIST.CALL_CAMPAIGN.FILTER.SORT.SCHEDULED_ASC',
  },
  {
    id: 3,
    order: 'scheduled_at',
    direction: 'desc',
    title:
      'CAMPAIGN.LLM_CHATBOT.AI_BROADCAST_LIST.CALL_CAMPAIGN.FILTER.SORT.SCHEDULED_DESC',
  },
  {
    id: 4,
    order: 'total_cost',
    direction: 'asc',
    title:
      'CAMPAIGN.LLM_CHATBOT.AI_BROADCAST_LIST.CALL_CAMPAIGN.FILTER.SORT.TOTAL_COST_ASC',
  },
  {
    id: 5,
    order: 'total_cost',
    direction: 'desc',
    title:
      'CAMPAIGN.LLM_CHATBOT.AI_BROADCAST_LIST.CALL_CAMPAIGN.FILTER.SORT.TOTAL_COST_DESC',
  },
  {
    id: 6,
    order: 'total_duration',
    direction: 'asc',
    title:
      'CAMPAIGN.LLM_CHATBOT.AI_BROADCAST_LIST.CALL_CAMPAIGN.FILTER.SORT.TOTAL_DURATION_ASC',
  },
  {
    id: 7,
    order: 'total_duration',
    direction: 'desc',
    title:
      'CAMPAIGN.LLM_CHATBOT.AI_BROADCAST_LIST.CALL_CAMPAIGN.FILTER.SORT.TOTAL_DURATION_DESC',
  },
  {
    id: 8,
    order: 'result_success',
    direction: 'asc',
    title:
      'CAMPAIGN.LLM_CHATBOT.AI_BROADCAST_LIST.CALL_CAMPAIGN.FILTER.SORT.RESULT_SUCCESS_ASC',
  },
  {
    id: 9,
    order: 'result_success',
    direction: 'desc',
    title:
      'CAMPAIGN.LLM_CHATBOT.AI_BROADCAST_LIST.CALL_CAMPAIGN.FILTER.SORT.RESULT_SUCCESS_DESC',
  },
  {
    id: 10,
    order: 'result_failure',
    direction: 'asc',
    title:
      'CAMPAIGN.LLM_CHATBOT.AI_BROADCAST_LIST.CALL_CAMPAIGN.FILTER.SORT.RESULT_FAILURE_ASC',
  },
  {
    id: 11,
    order: 'result_failure',
    direction: 'desc',
    title:
      'CAMPAIGN.LLM_CHATBOT.AI_BROADCAST_LIST.CALL_CAMPAIGN.FILTER.SORT.RESULT_FAILURE_DESC',
  },
  {
    id: 12,
    order: 'result_unknown',
    direction: 'asc',
    title:
      'CAMPAIGN.LLM_CHATBOT.AI_BROADCAST_LIST.CALL_CAMPAIGN.FILTER.SORT.RESULT_UNKNOWN_ASC',
  },
  {
    id: 13,
    order: 'result_unknown',
    direction: 'desc',
    title:
      'CAMPAIGN.LLM_CHATBOT.AI_BROADCAST_LIST.CALL_CAMPAIGN.FILTER.SORT.RESULT_UNKNOWN_DESC',
  },
  {
    id: 14,
    order: 'recipient_pending',
    direction: 'asc',
    title:
      'CAMPAIGN.LLM_CHATBOT.AI_BROADCAST_LIST.CALL_CAMPAIGN.FILTER.SORT.RECIPIENT_PENDING_ASC',
  },
  {
    id: 15,
    order: 'recipient_pending',
    direction: 'desc',
    title:
      'CAMPAIGN.LLM_CHATBOT.AI_BROADCAST_LIST.CALL_CAMPAIGN.FILTER.SORT.RECIPIENT_PENDING_DESC',
  },
  {
    id: 16,
    order: 'recipient_completed',
    direction: 'asc',
    title:
      'CAMPAIGN.LLM_CHATBOT.AI_BROADCAST_LIST.CALL_CAMPAIGN.FILTER.SORT.RECIPIENT_COMPLETED_ASC',
  },
  {
    id: 17,
    order: 'recipient_completed',
    direction: 'desc',
    title:
      'CAMPAIGN.LLM_CHATBOT.AI_BROADCAST_LIST.CALL_CAMPAIGN.FILTER.SORT.RECIPIENT_COMPLETED_DESC',
  },
];

export const OUTBOUND_CALL_CAMPAIGN_METRIC = [
  {
    NAME: 'CAMPAIGN.OUTBOUND_CALL_CAMPAIGN.METRIC.SUCCESS',
    KEY: 'success',
    DESC: '( total )',
  },
  {
    NAME: 'CAMPAIGN.OUTBOUND_CALL_CAMPAIGN.METRIC.FAILURE',
    KEY: 'failure',
    DESC: '( total )',
  },
  {
    NAME: 'CAMPAIGN.OUTBOUND_CALL_CAMPAIGN.METRIC.UNKNOWN',
    KEY: 'unknown',
    DESC: '( total )',
  },
  {
    NAME: 'CAMPAIGN.OUTBOUND_CALL_CAMPAIGN.METRIC.TOTAL_COST',
    KEY: 'total_cost',
    DESC: '( total )',
  },
  {
    NAME: 'CAMPAIGN.OUTBOUND_CALL_CAMPAIGN.METRIC.DURATION',
    KEY: 'total_duration',
    DESC: '( total )',
  },
];

export const OUTBOUND_CALL_CAMPAIGN_STATUS_METRIC = [
  {
    NAME: 'CAMPAIGN.OUTBOUND_CALL_CAMPAIGN.STATUS_METRIC.PENDING',
    KEY: 'pending',
    DESC: '( total )',
  },
  {
    NAME: 'CAMPAIGN.OUTBOUND_CALL_CAMPAIGN.STATUS_METRIC.ACTIVE',
    KEY: 'active',
    DESC: '( total )',
  },
  {
    NAME: 'CAMPAIGN.OUTBOUND_CALL_CAMPAIGN.STATUS_METRIC.RUNNING',
    KEY: 'running',
    DESC: '( total )',
  },
  {
    NAME: 'CAMPAIGN.OUTBOUND_CALL_CAMPAIGN.STATUS_METRIC.COMPLETED',
    KEY: 'completed',
    DESC: '( total )',
  },
  {
    NAME: 'CAMPAIGN.OUTBOUND_CALL_CAMPAIGN.STATUS_METRIC.DEACTIVATE',
    KEY: 'deactivate',
    DESC: '( total )',
  },
];

export const CALL_TWILIO_EVALUATION = [
  { id: 'success', title: 'CONTACT_PANEL.CALL.EVALUATION.SUCCESS' },
  { id: 'failure', title: 'CONTACT_PANEL.CALL.EVALUATION.FAILURE' },
  { id: 'unknown', title: 'CONTACT_PANEL.CALL.EVALUATION.UNKNOWN' },
];

export const CALL_TWILIO_DIRECTIONS = [
  { id: 0, title: 'CAMPAIGN.FILTERS.DIRECTION.LIST.OUTGOING' },
  { id: 1, title: 'CAMPAIGN.FILTERS.DIRECTION.LIST.INCOMMING' },
];

export const CALL_TWILIO_KINDS = [
  { id: 'agent', title: 'CAMPAIGN.FILTERS.CALL_KIND.LIST.AGENT' },
  { id: 'ai', title: 'CAMPAIGN.FILTERS.CALL_KIND.LIST.AI' },
];

export const AiBroadcastFilterTypes = [
  {
    attributeKey: 'name',
    attributeI18nKey: 'Name',
    inputType: 'plain_text',
    dataType: 'text',
    filterOperators: OPERATOR_TYPES_3,
    attribute_type: 'standard',
  },
  {
    attributeKey: 'status',
    attributeI18nKey: 'Status',
    inputType: 'search_select',
    dataType: 'text',
    filterOperators: OPERATOR_TYPES_1,
    attribute_type: 'standard',
  },
  {
    attributeKey: 'agent_name',
    attributeI18nKey: 'Agent Name',
    inputType: 'plain_text',
    dataType: 'text',
    filterOperators: OPERATOR_TYPES_3,
    attribute_type: 'standard',
  },
  {
    attributeKey: 'recipient_count',
    attributeI18nKey: 'Recipient Count',
    inputType: 'plain_text',
    dataType: 'number',
    filterOperators: OPERATOR_TYPES_5,
    attribute_type: 'standard',
  },
  {
    attributeKey: 'total_cost',
    attributeI18nKey: 'Total Cost',
    inputType: 'plain_text',
    dataType: 'number',
    filterOperators: OPERATOR_TYPES_5,
    attribute_type: 'standard',
  },
  {
    attributeKey: 'total_duration',
    attributeI18nKey: 'Total Duration',
    inputType: 'plain_text',
    dataType: 'number',
    filterOperators: OPERATOR_TYPES_5,
    attribute_type: 'standard',
  },
  {
    attributeKey: 'scheduled_at',
    attributeI18nKey: 'Scheduled At',
    inputType: 'plain_text',
    dataType: 'text',
    filterOperators: OPERATOR_TYPES_3,
    attribute_type: 'standard',
  },
];

export const AiBroadcastFilterAttributList = [
  {
    key: 'name',
    name:
      'CAMPAIGN.LLM_CHATBOT.AI_BROADCAST_LIST.CALL_CAMPAIGN.FILTER.LABEL.NAME',
  },
  {
    key: 'status',
    name:
      'CAMPAIGN.LLM_CHATBOT.AI_BROADCAST_LIST.CALL_CAMPAIGN.FILTER.LABEL.STATUS',
  },
  {
    key: 'agent_name',
    name: 'Agent Name',
  },
  {
    key: 'recipient_count',
    name: 'Recipient Count',
  },
];

export const OutboundCallCampaignFilterTypes = [
  {
    attributeKey: 'name',
    attributeI18nKey: 'Name',
    inputType: 'plain_text',
    dataType: 'text',
    filterOperators: OPERATOR_TYPES_3,
    attribute_type: 'standard',
  },
  {
    attributeKey: 'status',
    attributeI18nKey: 'Status',
    inputType: 'search_select',
    dataType: 'text',
    filterOperators: OPERATOR_TYPES_1,
    attribute_type: 'standard',
  },
  {
    attributeKey: 'agent_name',
    attributeI18nKey: 'Agent Name',
    inputType: 'plain_text',
    dataType: 'text',
    filterOperators: OPERATOR_TYPES_3,
    attribute_type: 'standard',
  },
];

export const OutboundCallCampaignAttributeList = [
  {
    key: 'name',
    name:
      'CAMPAIGN.LLM_CHATBOT.AI_BROADCAST_LIST.CALL_CAMPAIGN.FILTER.LABEL.NAME',
  },
  {
    key: 'status',
    name:
      'CAMPAIGN.LLM_CHATBOT.AI_BROADCAST_LIST.CALL_CAMPAIGN.FILTER.LABEL.STATUS',
  },
  {
    key: 'agent_name',
    name: 'Agent Name',
  },
];

export const llmReportFilterTypes = [
  {
    attributeKey: 'contact_name',
    attributeI18nKey: 'Contact Name',
    inputType: 'plain_text',
    dataType: 'text',
    filterOperators: OPERATOR_TYPES_3,
    attribute_type: 'standard',
  },
  {
    attributeKey: 'agent_name',
    attributeI18nKey: 'Agent Name',
    inputType: 'plain_text',
    dataType: 'text',
    filterOperators: OPERATOR_TYPES_3,
    attribute_type: 'standard',
  },
  {
    attributeKey: 'reference_id',
    attributeI18nKey: 'Reference id',
    inputType: 'plain_text',
    dataType: 'text',
    filterOperators: OPERATOR_TYPES_3,
    attribute_type: 'standard',
  },
  {
    attributeKey: 'call_direction',
    attributeI18nKey: 'Direction',
    inputType: 'search_select',
    dataType: 'text',
    filterOperators: OPERATOR_TYPES_1,
    attribute_type: 'standard',
  },
  {
    attributeKey: 'agent_type',
    attributeI18nKey: 'Type',
    inputType: 'search_select',
    dataType: 'text',
    filterOperators: OPERATOR_TYPES_1,
    attribute_type: 'standard',
  },
];

export const llmReportFilterAttributList = [
  {
    key: 'contact_name',
    name: 'CAMPAIGN.EVALUATIONS.FILTERS.ATTRIBUTES.CONTACT_NAME',
  },
  {
    key: 'agent_name',
    name: 'CAMPAIGN.EVALUATIONS.FILTERS.ATTRIBUTES.AGENT_NAME',
  },
  {
    key: 'reference_id',
    name:
      'CAMPAIGN.LLM_CHATBOT.AI_BROADCAST_LIST.CALL_CAMPAIGN.FILTER.LABEL.REFERENCE_ID',
  },
  {
    key: 'call_direction',
    name: 'CAMPAIGN.FILTERS.DIRECTION.LABEL',
  },
  {
    key: 'agent_type',
    name: 'CAMPAIGN.FILTERS.CALL_KIND.LABEL',
  },
];

// Audience Filter Constants
export const AUDIENCE_CALL_STATUS = [
  {
    id: 'success',
    title: 'CAMPAIGN.OUTBOUND_CALL_CAMPAIGN.DETAILS.METRIC.SUCCESS',
  },
  {
    id: 'failed',
    title: 'CAMPAIGN.OUTBOUND_CALL_CAMPAIGN.DETAILS.METRIC.REJECT',
  },
  {
    id: 'retry',
    title: 'CAMPAIGN.OUTBOUND_CALL_CAMPAIGN.DETAILS.METRIC.RETRY',
  },
  {
    id: 'no_pickup',
    title: 'CAMPAIGN.OUTBOUND_CALL_CAMPAIGN.DETAILS.METRIC.NOT_CONNECTED',
  },
  {
    id: 'disqualified',
    title: 'CAMPAIGN.OUTBOUND_CALL_CAMPAIGN.DETAILS.METRIC.DISQUALIFIED',
  },
];

export const AudienceFilterTypes = [
  {
    attributeKey: 'contact_name',
    attributeI18nKey: 'Contact Name',
    inputType: 'plain_text',
    dataType: 'text',
    filterOperators: OPERATOR_TYPES_3,
    attribute_type: 'standard',
  },
  {
    attributeKey: 'phone_number',
    attributeI18nKey: 'Phone Number',
    inputType: 'plain_text',
    dataType: 'text',
    filterOperators: OPERATOR_TYPES_3,
    attribute_type: 'standard',
  },
  {
    attributeKey: 'call_status',
    attributeI18nKey: 'Outcome',
    inputType: 'search_select',
    dataType: 'text',
    filterOperators: OPERATOR_TYPES_1,
    attribute_type: 'standard',
  },
  {
    attributeKey: 'attempt',
    attributeI18nKey: 'Attempt',
    inputType: 'plain_text',
    dataType: 'number',
    filterOperators: OPERATOR_TYPES_5,
    attribute_type: 'standard',
  },
];

export const AudienceFilterAttributList = [
  {
    key: 'contact_name',
    name: 'Contact Name',
  },
  {
    key: 'phone_number',
    name: 'Phone Number',
  },
  {
    key: 'call_status',
    name: 'Outcome',
  },
  {
    key: 'attempt',
    name: 'Attempt',
  },
];
